import {
  Inserter,
  SessionRole,
  DragAndDropContext,
  TinymcePortal,
  RouterPageNotFound,
  ErrorBoundry,
  PartAdmin,
  PartMenu,
  Wrapper,
  Icon,
  Link,
} from "nystem-components";
import "./index.css";

const Index = () => {
  return (
  <ErrorBoundry fallback={<Inserter match="*" source="/page/view/404" />}>
    <DragAndDropContext>
      <TinymcePortal />
      <SessionRole userrole="logged-in">
        <Wrapper className="flex flex-col justify-center items-center ">
          <Link to="/admin">
            <Icon
              icon="gear"
              className="fixed right-0 top-0 z-200 hidden h-8 w-8 p-2 text-gray-500 md:block"
            />
          </Link>
        </Wrapper>
      </SessionRole>
      <Wrapper
        className="app-shell min-h-lvh bg-stone-100 font-sans text-stone-800 antialiased"
      >
        <PartMenu />
        <PartAdmin />
        <SessionRole userrole="logged-out">
          <Wrapper className="flex flex-col justify-center items-center ">
            <Inserter match="*" source="/user/login" />
          </Wrapper>
        </SessionRole>
        <Inserter match="/content/view/*" className="" />
        <SessionRole userrole="logged-in">
          <Inserter
            match="/customer/*"
            className="px-8 py-12 mx-auto max-w-3xl"
          />
          <Inserter
            match="/mission/*"
            className="mx-auto w-full max-w-5xl px-5 py-12 md:px-8"
          />
          <Inserter
            match="/"
            source="/mission/list"
            className="px-5 py-12 mx-auto w-full max-w-6xl md:px-8"
          />
          <RouterPageNotFound limit={3}>
            <Inserter
              match="*"
              source="/page/view/404"
              className="px-8 py-12 mx-auto max-w-3xl"
            />
          </RouterPageNotFound>
          <Inserter
            match="*"
            source="/content/footer/footer"
            className="footer"
          />
        </SessionRole>
      </Wrapper>
    </DragAndDropContext>
  </ErrorBoundry>
  );
};

export default Index;
